import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'cie-diagnostics',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'cie-diagnostics-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.cie-diagnostics-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "cie-diagnostics-index" */ '@/modules/configurations/catalogs/cie-diagnostics/views/Index.vue')
        },
        // HCSO-2909 · FR-010: el catálogo CIE-10 es de solo lectura; cualquier URL
        // de alta/edición/baja (marcadores viejos) regresa al listado con aviso.
        {
            path: ':pathMatch(.*)+',
            redirect: () => ({ name: 'cie-diagnostics-index', params: {}, query: { readonly: '1' } })
        }
    ]
}